module.exports = __webpack_public_path__ + "img/WPS图片3@2x.2d395ca4.png";